import { render, staticRenderFns } from "./AmListPage.vue?vue&type=template&id=34808cbf&"
import script from "./AmListPage.vue?vue&type=script&lang=js&"
export * from "./AmListPage.vue?vue&type=script&lang=js&"
import style0 from "./AmListPage.vue?vue&type=style&index=0&id=34808cbf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports